<template>
  <b-modal id="invite-user-modal"
          @ok="handleInvite"
          ok-title='Invite'
          header-class="pb-0"
          body-class="py-0"
          centered
          button-size="sm"
          header-bg-variant="secondary"
          body-bg-variant="secondary"
          footer-bg-variant="secondary"
          :key="activeProjectId">
    <template>
      <div>
        <b-form  @submit.stop.prevent>
            <label for="invite-email-input" size="sm">Email for invite:</label>
            <b-input v-model="email" size="sm" id="invite-email-input" type="email"></b-input>
            <b-form-select
                v-model="selectedRole"
                :options="assignableRoles"
                class="mt-3"
                size="md"
            >
            </b-form-select>
            <b-form-invalid-feedback :state="invalidText === undefined">
              {{invalidText}}
            </b-form-invalid-feedback>
        </b-form>

      </div>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { RoleInviteUserRequest, AccountRoleRequest, ProjectRoleItem } from '#/protobuf/service_account_pb';

export default {
  props: {
    assignableRoles: {
      type: Array,
      required: true,
    },
    // will grab project from route and invite to project instead of account
    isProjectInvite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: '',
      selectedRole: 0,
      invalidText: undefined,
    };
  },
  computed: {
    ...mapGetters([
      'activeProjectId',
    ]),
    valid() {
      return true;
    },
    showError() {
      return true;
    },
  },
  methods: {
    handleInvite(bvModalEvt) {
      console.log('handling invite...', this.email, this.selectedRole);
      bvModalEvt.preventDefault();
      //   if (!this.valid) {
      //     return Promise.reject();
      //   }
      const request = new RoleInviteUserRequest();
      request.setEmail(this.email);
      request.setShouldSendEmail(true);
      if (this.isProjectInvite) {
        const projectRole = new ProjectRoleItem();
        projectRole.setProjectId(this.activeProjectId);
        projectRole.setProjectRole(this.selectedRole);
        request.setProjectModification(projectRole);
        console.log('sending project invite', request.toObject());
      } else {
        const accountRole = new AccountRoleRequest();
        accountRole.setAccountRoleId(this.selectedRole);
        request.setAccountModification(accountRole);
        console.log('sending account invite', request.toObject());
      }

      return this.$store.dispatch('accounts/inviteUser', request).then((response) => {
        console.log('RESPONSE handleInvite', response);
        this.$nextTick(() => {
          this.email = '';
          this.$bvModal.hide('invite-user-modal');
          this.$bvToast.toast('invitation sent successfully', {
            title: 'Success',
            autoHideDelay: 1000,
            variant: 'primary',
            appendToast: true
          });
        });
      }).catch((error) => {
        console.log('handleInvite error', error.message);
        this.invalidText = error.message;
        // this.$bvToast.toast(error.message, {
        //   title: 'Error',
        //   autoHideDelay: 5000,
        //   variant: 'danger',
        //   appendToast: true
        // });
      });

      // TODO: handle error
      // this.$nextTick(() => {
      //   this.$bvModal.hide('invite-user-modal');
      // });
    },
  },
};
</script>
